import * as S from './style';

export type VehicleBadgeType = {
  img: string;
  title: string;
  value: string;
};

const VehicleBadge = ({ img, title, value }: VehicleBadgeType) => {
  return (
    <S.Wrapper>
      <S.VehicleImg>
        <S.Img src={img} alt="Vehicle Image" />
      </S.VehicleImg>
      <S.VehicleContent>
        <S.Subtitle>{value}</S.Subtitle>
        <S.Value>{title}</S.Value>
      </S.VehicleContent>
    </S.Wrapper>
  );
};

export default VehicleBadge;
